// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckBoxIcon_checkbox__WC6dm","checked":"CheckBoxIcon_checked__9PJFT"};